/**
 * Created by jiachenpan on 16/11/18.
 */

export function openwindow(url,name)
 {
  var iWidth=window.screen.width*0.75;                         //弹出窗口的宽度;
  var iHeight=window.screen.height*0.75;                        //弹出窗口的高度;
  //window.screen.height获得屏幕的高，window.screen.width获得屏幕的宽
  var iTop = (window.screen.height-30-iHeight)/2;       //获得窗口的垂直位置;
  var iLeft = (window.screen.width-10-iWidth)/2;        //获得窗口的水平位置;
  var myWindow=window.open(url,name,'height='+iHeight+',innerHeight='+iHeight+',width='+iWidth+',innerWidth='+iWidth+',top='+iTop+',left='+iLeft+',toolbar=no, menubar=no,location=no, status=no');
  myWindow.focus();

 }


export function div1000(value) {
	if(value) {

		return Math.round(value / 1000)
	} else {
		return 0
	}

}

export function Trim(str) {
	
    if(typeof str == "undefined" || str == null){
        return "";
    }	
	
	return str.replace(/(^\s*)|(\s*$)/g, "");
}
const datepickerOptions = {
	disabledDate(time) {
		return time.getTime() > Date.now();
	},
	shortcuts: [{
		text: '今天',
		onClick(picker) {
			picker.$emit('pick', new Date());
		}
	}, {
		text: '昨天',
		onClick(picker) {
			const date = new Date();
			date.setTime(date.getTime() - 3600 * 1000 * 24);
			picker.$emit('pick', date);
		}
	}, {
		text: '一周前',
		onClick(picker) {
			const date = new Date();
			date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
			picker.$emit('pick', date);
		}
	}]
}

const datepickerOptions2 = {
	shortcuts: [{
		text: '最近一周',
		onClick(picker) {
			const end = new Date();
			const start = new Date();
			start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
			picker.$emit('pick', [start, end]);
		}
	}, {
		text: '最近一个月',
		onClick(picker) {
			const end = new Date();
			const start = new Date();
			start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
			picker.$emit('pick', [start, end]);
		}
	}, {
		text: '最近三个月',
		onClick(picker) {
			const end = new Date();
			const start = new Date();
			start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
			picker.$emit('pick', [start, end]);
		}
	}]
}

export {
	datepickerOptions,
	datepickerOptions2
}

export function findKindName(dict, val) {
	if(!val) return '';
	let obj = {};
	obj = dict.find((item) => {
		return item.kindid === val;
	});

	return obj.kindname;
}
export function datestrTotimestamp(datastr) {
	//if(datastr.length == 10) datastr += " 00:00:00";
	//let timestamp = new Date(datastr).getTime();
	return datastr;
}

export function parseTime(time, cFormat) {
	if (!time){
		return null
	}
	
	if(arguments.length === 0) {
		return null
	}
	const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
	let date
	if(typeof time === 'object') {
		date = time
	} else {
		if(('' + time).length === 10) time = parseInt(time) * 1000
		date = new Date(time)
	}
	const formatObj = {
		y: date.getFullYear(),
		m: date.getMonth() + 1,
		d: date.getDate(),
		h: date.getHours(),
		i: date.getMinutes(),
		s: date.getSeconds(),
		a: date.getDay()
	}
	const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
		let value = formatObj[key]
		if(key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
		if(result.length > 0 && value < 10) {
			value = '0' + value
		}
		return value || 0
	})
	return time_str
}

export function formatTime(time, option) {
	time = +time * 1000
	const d = new Date(time)
	const now = Date.now()

	const diff = (now - d) / 1000

	if(diff < 30) {
		return '刚刚'
	} else if(diff < 3600) { // less 1 hour
		return Math.ceil(diff / 60) + '分钟前'
	} else if(diff < 3600 * 24) {
		return Math.ceil(diff / 3600) + '小时前'
	} else if(diff < 3600 * 24 * 2) {
		return '1天前'
	}
	if(option) {
		return parseTime(time, option)
	} else {
		return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
	}
}

// 格式化时间
export function getQueryObject(url) {
	url = url == null ? window.location.href : url
	const search = url.substring(url.lastIndexOf('?') + 1)
	const obj = {}
	const reg = /([^?&=]+)=([^?&=]*)/g
	search.replace(reg, (rs, $1, $2) => {
		const name = decodeURIComponent($1)
		let val = decodeURIComponent($2)
		val = String(val)
		obj[name] = val
		return rs
	})
	return obj
}

/**
 *get getByteLen
 * @param {Sting} val input value
 * @returns {number} output value
 */
export function getByteLen(val) {
	let len = 0
	for(let i = 0; i < val.length; i++) {
		if(val[i].match(/[^\x00-\xff]/ig) != null) {
			len += 1
		} else {
			len += 0.5
		}
	}
	return Math.floor(len)
}

export function cleanArray(actual) {
	const newArray = []
	for(let i = 0; i < actual.length; i++) {
		if(actual[i]) {
			newArray.push(actual[i])
		}
	}
	return newArray
}

export function param(json) {
	if(!json) return ''
	return cleanArray(Object.keys(json).map(key => {
		if(json[key] === undefined) return ''
		return encodeURIComponent(key) + '=' +
			encodeURIComponent(json[key])
	})).join('&')
}

export function param2Obj(url) {
	const search = url.split('?')[1]
	if(!search) {
		return {}
	}
	return JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
}

export function html2Text(val) {
	const div = document.createElement('div')
	div.innerHTML = val
	return div.textContent || div.innerText
}

export function objectMerge(target, source) {
	/* Merges two  objects,
	   giving the last one precedence */

	if(typeof target !== 'object') {
		target = {}
	}
	if(Array.isArray(source)) {
		return source.slice()
	}
	Object.keys(source).forEach((property) => {
		const sourceProperty = source[property]
		if(typeof sourceProperty === 'object') {
			target[property] = objectMerge(target[property], sourceProperty)
		} else {
			target[property] = sourceProperty
		}
	})
	return target
}

export function scrollTo(element, to, duration) {
	if(duration <= 0) return
	const difference = to - element.scrollTop
	const perTick = difference / duration * 10
	setTimeout(() => {
		console.log(new Date())
		element.scrollTop = element.scrollTop + perTick
		if(element.scrollTop === to) return
		scrollTo(element, to, duration - 10)
	}, 10)
}

export function toggleClass(element, className) {
	if(!element || !className) {
		return
	}
	let classString = element.className
	const nameIndex = classString.indexOf(className)
	if(nameIndex === -1) {
		classString += '' + className
	} else {
		classString = classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length)
	}
	element.className = classString
}

export const pickerOptions = [{
	text: '今天',
	onClick(picker) {
		const end = new Date()
		const start = new Date(new Date().toDateString())
		end.setTime(start.getTime())
		picker.$emit('pick', [start, end])
	}
}, {
	text: '最近一周',
	onClick(picker) {
		const end = new Date(new Date().toDateString())
		const start = new Date()
		start.setTime(end.getTime() - 3600 * 1000 * 24 * 7)
		picker.$emit('pick', [start, end])
	}
}, {
	text: '最近一个月',
	onClick(picker) {
		const end = new Date(new Date().toDateString())
		const start = new Date()
		start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
		picker.$emit('pick', [start, end])
	}
}, {
	text: '最近三个月',
	onClick(picker) {
		const end = new Date(new Date().toDateString())
		const start = new Date()
		start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
		picker.$emit('pick', [start, end])
	}
}]

export function getTime(type) {
	if(type === 'start') {
		return new Date().getTime() - 3600 * 1000 * 24 * 90
	} else {
		return new Date(new Date().toDateString())
	}
}

export function debounce(func, wait, immediate) {
	let timeout, args, context, timestamp, result

	const later = function() {
		// 据上一次触发时间间隔
		const last = +new Date() - timestamp

		// 上次被包装函数被调用时间间隔last小于设定时间间隔wait
		if(last < wait && last > 0) {
			timeout = setTimeout(later, wait - last)
		} else {
			timeout = null
			// 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
			if(!immediate) {
				result = func.apply(context, args)
				if(!timeout) context = args = null
			}
		}
	}

	return function(...args) {
		context = this
		timestamp = +new Date()
		const callNow = immediate && !timeout
		// 如果延时不存在，重新设定延时
		if(!timeout) timeout = setTimeout(later, wait)
		if(callNow) {
			result = func.apply(context, args)
			context = args = null
		}

		return result
	}
}

export function deepClone(source) {
	if(!source && typeof source !== 'object') {
		throw new Error('error arguments', 'shallowClone')
	}
	const targetObj = source.constructor === Array ? [] : {}
	Object.keys(source).forEach((keys) => {
		if(source[keys] && typeof source[keys] === 'object') {
			targetObj[keys] = source[keys].constructor === Array ? [] : {}
			targetObj[keys] = deepClone(source[keys])
		} else {
			targetObj[keys] = source[keys]
		}
	})
	return targetObj
}

export function jsontoarray(jsondata) {
	let data = [];
	let tableTitle = [];
	let talleValue = [];

	for(let key in jsondata) {
		if(typeof jsondata[key] != "object") {
			tableTitle.push(key)
			talleValue.push(jsondata[key])
		}

	}

	data.push(tableTitle);
	data.push(talleValue);

	tableTitle = [];
	talleValue = [];

	for(let key in jsondata) {
		if(typeof jsondata[key] === "object") {
			if(jsondata[key].length > 0) {
				for(let i = 0; i < jsondata[key].length; i++) {
					for(let subkey in jsondata[key][i]) {
						if(i == 0) tableTitle.push(subkey);
						talleValue.push(jsondata[key][i][subkey]);
					}

					if(i == 0) data.push(tableTitle);
					data.push(talleValue);
					talleValue = [];
				}

			}

		}

	}

	return data;

}

export function getElementLeft(element) {　　　　
	var actualLeft = element.offsetLeft;　　　　
	var current = element.offsetParent;

	　　　　
	while(current !== null) {　　　　　　
		actualLeft += current.offsetLeft;　　　　　　
		current = current.offsetParent;　　　　
	}

	　　　　
	return actualLeft;　　
}

　
export　 function getElementTop(element) {　　　　
	var actualTop = element.offsetTop;　　　　
	var current = element.offsetParent;

	　　　　
	while(current !== null) {　　　　　　
		actualTop += current.offsetTop;　　　　　　
		current = current.offsetParent;　　　　
	}

	　　　　
	return actualTop;　　
}

export function isEmpty(obj) {
    obj=Trim(obj);
	if(typeof obj == "undefined" || obj == null || obj == "") {
		return true;
	} else {
		return false;
	}

}

export function CheckDecimal(obj) {
	var temp = /^\d+\.?\d{0,4}$/;
	if(temp.test(obj.value)) {} else {
		obj.value = obj.value.substr(0, obj.value.length - 1);
		IWS_CheckDecimal(obj);
	}
}

   //保留4位小数，
 export  function toDecimal4(x) { 
 	 var f = parseFloat(x);
 	 if (isNaN(f)) {  
 	 return 0;     
        }       
     var f = Math.round(x*10000)/10000; 
     
     return f; 
}
 
   //转换为Float，
 export  function toFloat(x) { 
 	 var f = parseFloat(x);
 	 if (isNaN(f)) {  
 	 return 0;     
        }       
    
     return f; 
}
 